module.exports = __webpack_public_path__ + "img/pharma.dfade909.svg";